import { Injectable } from '@angular/core';
import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import {
  ChangePasswordSI,
  CreateAccountRequestSI,
  RecoverEmailRequestSI,
  RecoverEmailResponseSI,
  UpdateEmailRequestSI,
  UpdateEmailResponseSI,
  ValidationSI,
} from '@interfaces/services/validation';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import { UserRequest } from '@views/interfaces/services/users.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) {}

  async login({ user, password, token }): Promise<ValidationSI> {
    const result = await firstValueFrom<ResponseCommonSI<ValidationSI>>(
      this.http.post(
        `${BASE_URL}${ENDPOINTS.LOGIN}`,
        {
          username: user,
          password,
        },
        {
          headers: { captchaToken: token },
        }
      )
    );
    return result.payload;
  }

  async changePassword({ oldPassword, newPassword }): Promise<boolean> {
    const result = await firstValueFrom<ResponseCommonSI<ChangePasswordSI>>(
      this.http.post(`${BASE_URL}${ENDPOINTS.CHANGE_PASSWORD}`, {
        oldPassword,
        newPassword,
      })
    );
    return result.payload.isValid;
  }

  async logOut(): Promise<{}> {
    const result = await firstValueFrom<ResponseCommonSI<{}>>(
      this.http.get(`${BASE_URL}${ENDPOINTS.LOGOUT}`)
    );
    return result.payload;
  }

  async recoverEmail(
    request: RecoverEmailRequestSI,
    token
  ): Promise<RecoverEmailResponseSI> {
    const result = await firstValueFrom<
      ResponseCommonSI<RecoverEmailResponseSI>
    >(
      this.http.post<ResponseCommonSI<RecoverEmailResponseSI>>(
        `${BASE_URL}${ENDPOINTS.RECOVER_EMAIL}`,
        request,
        {
          headers: { captchaToken: token },
        }
      )
    );
    return result.payload;
  }

  async updateEmail(
    request: UpdateEmailRequestSI,
    token
  ): Promise<UpdateEmailResponseSI> {
    const result = await firstValueFrom<
      ResponseCommonSI<UpdateEmailResponseSI>
    >(
      this.http.put<ResponseCommonSI<UpdateEmailResponseSI>>(
        `${BASE_URL}${ENDPOINTS.RECOVER_EMAIL}`,
        request,
        {
          headers: { captchaToken: token },
        }
      )
    );
    return result.payload;
  }

  async createAccount(
    request: CreateAccountRequestSI,
    token
  ): Promise<RecoverEmailResponseSI> {
    const result = await firstValueFrom<
      ResponseCommonSI<RecoverEmailResponseSI>
    >(
      this.http.post<ResponseCommonSI<RecoverEmailResponseSI>>(
        `${BASE_URL}${ENDPOINTS.CREATE_ACCOUNT}`,
        request,
        {
          headers: { captchaToken: token },
        }
      )
    );
    return result.payload;
  }
  async updateStatusPolicies() {
    await firstValueFrom(
      this.http.post(`${BASE_URL}${ENDPOINTS.UPDATESTATUSPOLICIES}`, {})
    );
  }

  public async recoverPassword(user: UserRequest) {
    return await firstValueFrom<ResponseCommonSI<any>>(
      this.http.put<ResponseCommonSI<any>>(
        `${BASE_URL}${ENDPOINTS.RECOVER_PASSWORD}`,
        user
      )
    );
  }

  public async changePasswordWithToken(password: string, token: string) {
    const result = await firstValueFrom<ResponseCommonSI<any>>(
      this.http.put(
        `${BASE_URL}${ENDPOINTS.CHANGE_PASSWORD_WITH_TOKEN}/${token}`,
        {
          password,
        }
      )
    );

    return true;
  }
}
